import LandingPage from '@components/LandingPage/LandingPage'

LandingPage.layout = 'none'

export default LandingPage
